module.exports = __webpack_public_path__ + "static/Pump-Station-pg3-7c673a0ab94792f5e5355b7fb78904e4.jpg";